"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PosResource = exports.CashResource = void 0;
/** Till and shift management (TZ §19). */
class CashResource {
    http;
    constructor(http) {
        this.http = http;
    }
    registers(branchId) {
        return this.http.get('cash/registers', { query: { branchId } });
    }
    createRegister(payload) {
        return this.http.post('cash/registers', payload);
    }
    /**
     * The shift currently open at this branch, if any.
     *
     * Scoped by branch rather than terminal: a cashier who moves to the second
     * till mid-shift is still working the same shift, and asking by device id
     * would hand them a second one.
     */
    currentShift(branchId) {
        return this.http.get('cash/shifts/current', {
            query: { branchId },
        });
    }
    getShift(shiftId) {
        return this.http.get(`cash/shifts/${shiftId}`);
    }
    openShift(payload) {
        return this.http.post('cash/shifts/open', payload);
    }
    /** Totals to show the cashier before they confirm the count. */
    shiftSummary(shiftId) {
        return this.http.get(`cash/shifts/${shiftId}/summary`);
    }
    closeShift(shiftId, payload) {
        return this.http.post(`cash/shifts/${shiftId}/close`, payload);
    }
    listShifts(query) {
        return this.http.getPaginated('cash/shifts', { query });
    }
    listTransactions(shiftId, query) {
        return this.http.getPaginated(`cash/shifts/${shiftId}/transactions`, {
            query,
        });
    }
    /** Manual cash in/out during a shift. Only those two types are accepted. */
    addTransaction(shiftId, payload) {
        return this.http.post(`cash/shifts/${shiftId}/transactions`, payload);
    }
}
exports.CashResource = CashResource;
/**
 * POS-specific endpoints, including the offline sync batch.
 */
class PosResource {
    http;
    constructor(http) {
        this.http = http;
    }
    /**
     * Pushes orders queued while the terminal was offline (TZ §18).
     *
     * Each entry carries its own `clientUuid`; the backend de-duplicates on it, so
     * replaying the same batch is safe and returns the same server ids.
     */
    syncOrders(orders) {
        return this.http.post('pos/sync/orders', { orders });
    }
    /** Menu + branch config snapshot the terminal caches for offline operation. */
    bootstrap(branchId) {
        return this.http.get('pos/bootstrap', { query: { branchId } });
    }
}
exports.PosResource = PosResource;
//# sourceMappingURL=pos.js.map